'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createUrlBuilder = createUrlBuilder;
exports.hash2query = hash2query;

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var substitutionPattern = /{[a-zA-Z0-9]+}/;

/**
 * @param pathPrefix {string} domain with optional prefix
 */
function createUrlBuilder(pathPrefix) {
    _auroraJavascriptUtils.assert.string(pathPrefix);

    return function (url) {
        var pathSubstitutions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var filledUrl = url;
        _underscore2.default.forEach(_underscore2.default.keys(pathSubstitutions), function (key) {
            filledUrl = filledUrl.replace('{' + key + '}', pathSubstitutions[key]);
        });

        if (substitutionPattern.exec(filledUrl)) {
            throw new Error('not all substitutions provided! in url=\'' + url + '\'');
        }

        return '' + pathPrefix + filledUrl;
    };
}

function hash2query(hash) {
    var result = '';

    _underscore2.default.forEach(_underscore2.default.keys(hash), function (attrName) {
        var attrValue = hash[attrName];
        // empty string will be attached as query parameter
        if (!_underscore2.default.isBoolean(attrValue) && !attrValue && !_underscore2.default.isString(attrValue)) {
            return;
        }

        if (attrValue instanceof _nestedHateoasCommonModels.Enum) {
            attrValue = attrValue.name;
        }

        var encodedAttrValue = encodeURIComponent(attrValue);
        result = result + ('&' + attrName + '=' + encodedAttrValue);
    });

    return result;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/urlUtils.js
// module id = 344
// module chunks = 118